import React from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Menu from '../../Menu';
import Dashboard from '../pages/Dashboard';
import NotFoundPage from '../pages/NotFoundPage';
import queryString from 'query-string';
import MainComponent from '~/components/MainComponent';

function MainContent() {
    const location = useLocation();
    const { redirectTo } = queryString.parse(location.search);

    const itemType = (item) => {
        if (!item.submenu) return 'menu';
        if (item.submenu) return 'submenu';
    };

    return (
        <section className="section-container">
            <div className="content-wrapper">
                <Routes>
                    <Route
                        path="/"
                        element={<Dashboard />}
                    />

                    {Menu.map((item, index) => {
                        if (itemType(item) === 'menu') {
                            const Component = item.component;
                            if (item.id === 'logout') return;

                            return (
                                <Route
                                    key={index}
                                    path={item.path}
                                    element={
                                        <>
                                            <MainComponent
                                                menu={item}
                                                Component={Component}
                                            />
                                        </>
                                    }
                                ></Route>
                            );
                        }
                        if (itemType(item) === 'submenu') {
                            {
                                return item.submenu.map((subitem, i) => {
                                    const Component = subitem.component;

                                    return (
                                        <Route
                                            key={i}
                                            path={subitem.path}
                                            element={
                                                <>
                                                    <MainComponent
                                                        menu={subitem}
                                                        Component={Component}
                                                    />
                                                </>
                                            }
                                        ></Route>
                                    );
                                });
                            }
                        }
                    })}
                    {['/login', '/retrieve-password'].includes(location.pathname) ? (
                        <Route
                            path="*"
                            element={
                                <Navigate
                                    to={redirectTo ? `../${redirectTo}` : '/'}
                                    replace
                                />
                            } //https://stackoverflow.com/a/69872699/11297747
                        />
                    ) : (
                        <Route
                            path="*"
                            element={<NotFoundPage />}
                        />
                    )}
                </Routes>
            </div>
        </section>
    );
}

export default React.memo(MainContent);
